import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

export interface DownloadListItem {
    img: string;
    url: string;
}
@Component
export default class EpicDownloadAgentGuide extends Vue {
    @Prop({ default: 'GET RIFO AGENT APP' })
    public title!: string;

    @Prop({ default: 'SAVE TIME | SAVE MONEY | LESS WORRIES' })
    public subTitle!: string;

    @Prop({
        default: function () {
            return [{
                img: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/download-app.png',
                url: 'https://itunes.apple.com/ca/app/rifo-agent/id1432625809?mt=8&from=singlemessage&isappinstalled=0  '
            }, {
                img: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/download-android.png',
                url: 'https://play.google.com/store/apps/details?id=ca.rifo.agentapp'
            }, {
                img: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/download-android-CN.png',
                url: 'https://apk.rifo.ca/apk/A-app-product-release.apk'
            }];
        }
    })
    public downloadList!: DownloadListItem[];

    @Prop({ default: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/snapshot.png' })
    public snapshot!: string;
}
